/* ==========================================================================
   Pila — Geo banner
   Offers the international waitlist to visitors outside the US. It is a
   suggestion, never a redirect and never a modal: the page they asked for
   stays exactly where it is, and dismissing it sticks.
   ========================================================================== */

(function () {
  'use strict';

  // Bump the suffix to show the bar again to people who already dismissed it,
  // e.g. when a launch makes the message materially different.
  var DISMISS_KEY = 'pila:geo-banner:dismissed:v1';

  // Longest country name the CTA can carry before the pill button stops
  // fitting, which matters most on mobile where it goes full width and the
  // label does not wrap. "United Kingdom" is 14 and should still fit;
  // "Central African Republic" is 24 and should not be attempted.
  var MAX_CTA_COUNTRY = 15;

  function dismissed() {
    try {
      return window.localStorage.getItem(DISMISS_KEY) === '1';
    } catch (e) {
      // Private mode: better to show a dismissible bar than to crash.
      return false;
    }
  }

  function remember() {
    try {
      window.localStorage.setItem(DISMISS_KEY, '1');
    } catch (e) { /* nothing to do, and nothing worth failing over */ }
  }

  function countryName(code) {
    try {
      return new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' })
        .of(code) || code;
    } catch (e) {
      return code;
    }
  }

  // Country lists come from a comma-separated theme setting, so "US, CA"
  // arrives with a leading space on the second entry. Normalise rather than
  // relying on whoever edits the setting to omit the space.
  function codeList(value) {
    if (!value) return [];
    var raw = Array.isArray(value) ? value : String(value).split(',');
    return raw
      .map(function (c) { return String(c).trim().toUpperCase(); })
      .filter(function (c) { return /^[A-Z]{2}$/.test(c); });
  }

  // A CTA naming the visitor's country reads as a vote rather than a signup,
  // but only while the name is short enough to fit the button.
  function fillCta(template, name, fallback) {
    if (!template || template.indexOf('{country}') === -1) return template;
    if (name.length > MAX_CTA_COUNTRY && fallback) return fallback;
    return template.replace(/\{country\}/g, name);
  }

  function init(root, config) {
    var home = codeList(config.homeCountries);
    var near = codeList(config.nearCountries);

    // Never offer the waitlist on the waitlist page.
    if (config.targetPath &&
        window.location.pathname.indexOf(config.targetPath) === 0) return;

    if (dismissed()) return;

    var textEl    = root.querySelector('[data-geo-text]');
    var linkEl    = root.querySelector('[data-geo-link]');
    var dismissEl = root.querySelector('[data-geo-dismiss]');

    dismissEl.addEventListener('click', function () {
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      remember();
    });

    window.PilaGeo.detect(config.apiBase).then(function (code) {
      // No answer, or home market: say nothing. An unknown visitor is far
      // more likely to be American than to be worth interrupting.
      if (!code || home.indexOf(code) !== -1) return;

      var isNear = near.indexOf(code) !== -1;
      var name = countryName(code);
      var template = isNear ? config.nearText : config.worldText;

      textEl.innerHTML = template.replace(
        /\{country\}/g,
        '<span class="pila-geo__country"></span>'
      );
      var slot = textEl.querySelector('.pila-geo__country');
      if (slot) slot.textContent = name;

      linkEl.textContent = fillCta(
        isNear ? config.nearCta : config.worldCta,
        name,
        config.ctaFallback
      );
      linkEl.href = config.targetPath + '?country=' + encodeURIComponent(code);

      root.setAttribute('aria-hidden', 'false');
      root.classList.add('is-visible');
    });
  }

  window.PilaGeoBanner = { init: init };
})();
